export const defaultRoutes = [
  {
    name: 'help-center',
    path: '/',
    component: () => import('@/App.ce.vue'),
  },
  {
    path: '/partner',
    name: 'partner-menu',
    component: () => import('@/pages/partners/Menu.vue'),
  },
  {
    path: '/partner/:slug',
    name: 'partner-faq',
    component: () => import('@/pages/partners/FAQ.vue'),
  },
  {
    path: '/partner/:slug/:childSlug',
    name: 'partner-faq-child',
    component: () => import('@/pages/partners/FAQ.vue'),
  },
  {
    path: '/guides',
    name: 'guides-menu',
    component: () => import('@/pages/guides/Menu.vue'),
  },
  {
    path: '/guides/:slug',
    name: 'guides-faq',
    component: () => import('@/pages/guides/FAQ.vue'),
  },
  {
    path: '/guides/:slug/:childSlug',
    name: 'guides-faq-child',
    component: () => import('@/pages/guides/FAQ.vue'),
  },
  {
    path: '/travelers',
    name: 'travelers-faq',
    component: () => import('@/pages/travelers/FAQ.vue'),
  },
];
